import { graphql } from 'react-apollo'
import { DELETE_FILES } from '../../graphql/mutations'

export default graphql(DELETE_FILES, { name: 'deleteFiles' })
